import { useEffect, useState } from "react";
import { Box, useMediaQuery, IconButton } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Navbar from "components/Navbar";
import Sidebar from "components/Sidebar";
import { useGetStudentsQuery } from "state/api";
import { RootState } from "state";
import { Menu as MenuIcon } from "@mui/icons-material";
import FlexBetween from "../../components/FlexBetween";

const Layout = () => {
    const [skip, setSkip] = useState(true);
    const isNonMobile = useMediaQuery("(min-width: 600px)");
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const { user } = useSelector((state: RootState) => state.auth);
    useEffect(() => {
        if (user && user.school_id > 0) {
            setSkip(false);
        }
    }, [user]);
    const { data } = useGetStudentsQuery(Number(user?.school_id), { skip });
    return (
        <Box sx={{
            border: `1px`,
            display: "flex",
            flexDirection: "column",
            height: "100vh",
        }}>
            <Box sx={{ border: '1px', position: 'fixed', width: '100%'}}>
                <Navbar
                    user={user}
                    isSidebarOpen={isSidebarOpen}
                    setIsSidebarOpen={setIsSidebarOpen}
                />
            </Box>
            <Box sx={{ width: '100%', marginTop: '100px' }}>
                <Box display="flex" flexDirection="row" sx={{ border: '1px' }} >
                <Box>
                    <Sidebar
                        user={user}
                        isNonMobile={isNonMobile}
                        drawerWidth="200px"
                        isSidebarOpen={isSidebarOpen}
                        setIsSidebarOpen={setIsSidebarOpen}
                        />
                 </Box>
                <Box>
                <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                    <MenuIcon />
                    </IconButton>
                </Box>

                <Box overflow="auto" sx={{ height: 'calc(100vh - 100px)', width: '100%' }}>
                    <Outlet />
                </Box>
                </Box>
            </Box>
        </Box>

    );
};

export default Layout;
